import React from 'react';
import Svg from '../Svg';

const IconCurrencyRubleCircle = ({ ...props }) => (
  <Svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12ZM8.5 6.5C8.5 5.94772 8.94772 5.5 9.5 5.5H14C15.933 5.5 17.5 7.067 17.5 9C17.5 10.933 15.933 12.5 14 12.5H10.5V13.75H13C13.5523 13.75 14 14.1977 14 14.75C14 15.3023 13.5523 15.75 13 15.75H10.5V17.5C10.5 18.0523 10.0523 18.5 9.5 18.5C8.94772 18.5 8.5 18.0523 8.5 17.5V15.75H8C7.44772 15.75 7 15.3023 7 14.75C7 14.1977 7.44772 13.75 8 13.75H8.5V12.5H8C7.44772 12.5 7 12.0523 7 11.5C7 10.9477 7.44772 10.5 8 10.5H8.5V6.5ZM10.5 7.5V10.5H14C14.8284 10.5 15.5 9.82843 15.5 9C15.5 8.17157 14.8284 7.5 14 7.5H10.5Z"
    />
  </Svg>
);

export default IconCurrencyRubleCircle;
